import { useApiCall } from "@/hooks/useApiCall";

export const useMsrManagementService = () => {
    const {get,put,...rest} = useApiCall()
    const fetchMsrYear = <T> () => get<T>("api/msr/v1/msr/msr_year/")
    const fetchMsrSeason = <T>() => get<T>("api/msr/v1/msr/msr_season/")
    const fetchMsrYearWiseSeasonList =<T> ()=> get<T>("api/msr/v1/msr/msr_season_year_wise_list/")
    const fetchSingleMsrSeasonYear = <T>(id:string) => get<T>(`api/msr/v1/msr/msr_season_year_create_together/${id}/`)
    const UpdateMsrSeasonYear = <T>(id:string,formData:FormData) => put<T>(`api/msr/v1/msr/msr_season_year_create_together/${id}/`,formData)

    return {fetchMsrYear,fetchMsrSeason,fetchMsrYearWiseSeasonList,fetchSingleMsrSeasonYear,UpdateMsrSeasonYear,...rest}
}